import { z } from 'zod';

/**
 * Account modules (owner, 26 September 2026: "we can maybe turn on and off modules like auto qa and
 * dialer etc from the admin portal").
 *
 * A module is a whole area of the product an account is sold: off, and its menu, its pages and its
 * API are gone for that account, and nothing of it runs in the background. It is switched by the
 * provider (platform or reseller, module:write), never by the account itself.
 *
 * Within a module that is on, a SEAT still needs its own feature: the dialler dials only for seats
 * whose type (or override) includes `dialer`; Auto QA marks only calls on seats with `auto_qa`.
 * The module is the account's; the feature is the seat's.
 */

export const MODULES = [
  {
    key: 'dialler',
    label: 'Dialler',
    description: 'Lead lists, campaigns (preview and auto), call scripts, the do-not-call list and campaign reports.',
    seat_feature: 'dialer',
  },
  {
    key: 'auto_qa',
    label: 'Auto QA',
    description: 'Calls transcribed and marked on the account’s own AI keys: scorecards, reports and search.',
    seat_feature: 'auto_qa',
  },
  {
    key: 'click_to_dial',
    label: 'Click to dial',
    description: 'The Chrome extension and the click-to-dial API: a seat rings, then dials the number clicked.',
    seat_feature: 'click_to_dial',
  },
] as const;

export type ModuleKey = (typeof MODULES)[number]['key'];
export const MODULE_KEYS = MODULES.map((m) => m.key) as unknown as readonly [ModuleKey, ...ModuleKey[]];

export interface AccountModule {
  key: ModuleKey;
  label: string;
  description: string;
  enabled: boolean;
  /** Seats whose package (or an override) includes the module's seat feature. */
  seats: number;
  changed_at: string | null;
  changed_by: string | null;
}

export const ModuleUpdateSchema = z.object({ enabled: z.boolean() }).strict();
